/**
 * Тексты блока About us. Менять копирайт здесь, не в JSX.
 */

export const ABOUT_COPY = {
    label: "About us",
    titleLines: ["We Build Digital Solutions", "That Transform Your Business"],
    description: "We're a team of developers who turn complex ideas into working code. From simple automation to enterprise-level systems, we create software that solves real problems and drives results for your business.",
    button: "Read More",
};

// config/about.js
